// extracted by mini-css-extract-plugin
export default {"service":"Service_service__yde54","serviceImage":"Service_serviceImage__q7kA4","serviceInfo":"Service_serviceInfo__-BHeY","serviceTitle":"Service_serviceTitle__3bGpE"};